import React, { useEffect, useState } from "react";
import { InputBase, MenuItem, Select } from "@mui/material";
import Box from "components/common/Box";
import Card from "components/common/Card";
import CardContent from "components/common/CardContent";
import Text from "components/common/Text";
import { makeStyles } from "@mui/styles";
import Paper from "components/common/Paper";
import IconButton from "components/common/IconButton";
import { GridSearchIcon } from "@mui/x-data-grid";
import CTable from "components/common/Table";
import Stack from "components/common/Stack";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
} from "@mui/material";
import * as XLSX from "xlsx";
import EventIcon from "@mui/icons-material/Event";
import Dialog from "components/common/Dialog";
import DatePickerModal from "components/common/DatePickerModal";
import { SearchHistoryApiData } from "stores/SearchHistory/SearchHistoryApi";

const filterData = ["All","Yes", "No"];

const columns = [
  {
    field: "customer_name",
    headerName: "Customer Name",
    valueGetter: (v, d) => (
      <>
        <span>{d?.customer_name === "null null" ? "-" : d?.customer_name}</span>
      </>
    ),
  },
  {
    field: "station_name",
    headerName: "Charging Station",
  },
  {
    field: "charging_networks",
    headerName: "Network",
  },
  {
    field: "date",
    headerName: "Date",
  },
  {
    field: "time",
    headerName: "Time",
  },
  {
    field: "check_in",
    headerName: "Check-In",
  },
];

const useStyles = makeStyles((theme) => ({
  table_date: {
    fontSize: "10px",
    height: "37px",
    fontWeight: "600",
    "@media (max-width:768px)": {
      width: "218%",
    },
  },
  searchBox: {
    float: "right",
    display: "flex",
    textAlign: "right",
    alignContent: "flex-end",
    borderRadius: "5px !important",
    marginBottom: "20px",
    marginTop: "1rem",
    "@media (max-width:768px)": {
      float: "none",
      marginTop: "-38px",
      marginBottom: "20px",
    },
  },
  exportfile: {
    background: "#19AA69",
    cursor: "pointer",
    height: "25px",
    borderRadius: "30px",
    color: "white",
    display: "flex",
    padding: "5px 15px",
  },
  center: {
    marginTop: "1.6rem",
  },
  searchHistory_heading: {
    fontSize: "22px",
    marginBottom: "40px",
  },
  searchHistory_heading_Container: {
    display: "flex",
    justifyContent: "space-between",
  },
  fileDownload_icon: {
    fontSize: "20px",
    marginTop: "3px",
  },
  searchBox_paper: {
    padding: "2.5px 0",
    display: "flex",
    alignItems: "center",
    width: "200px",
    height: "32px",
  },
}));

const SearchHistory = ({
  historydata,
  onChange,
  datePickerOpen,
  handleDatePickerOpen,
  handleDatePickerClose,
  from_date,
  to_date,
  searchhandleChange,
  limit,
  page,
  totalCount,
  onPageChange,
  fromat_date_from,
  fromat_date_to,
  onDatePickerSub,
  isLoading,
  handleReset,
  sortingValue,
  handleChangeSorting,
}) => {
  const classes = useStyles();
  const [searchHistoryExcelData, setSearchHistoryExcelData] = useState("");
  const filterdata = historydata;

  const downloadAsExcel = () => {
    const searchHistorydata = searchHistoryExcelData.map((d) => ({
      'Customer Name': d?.customer_name,
      'Charging Station': d?.station_name,
      Network: d?.charging_networks,
      Date: d?.date,
      Time: d?.time,
      'Check-In': d?.check_in,
    }));
    const worksheet = XLSX.utils.json_to_sheet(searchHistorydata);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "navigation Data");
    XLSX.writeFile(workbook, "SearchHistoryData.xlsx");
  };

  useEffect(() => {
    const fetchVehicleData = async () => {
      try {
        const limit = totalCount;
        const data = await SearchHistoryApiData.exportBulkApiData({ limit });
        setSearchHistoryExcelData(data?.result?.searchHistory);
      } catch (error) {
        console.error("Error exporting Navigation data:", error);
      }
    };

    fetchVehicleData();
  }, [totalCount]);

  return (
    <Box className={classes.center}>
      <Card>
        <CardContent>
          <Box>
            <Stack
              direction={{ sm: "column", xs: "column", md: "row" }}
              spacing={2}
              className={classes.searchHistory_heading_Container}
            >
              <Text
                variant="h5"
                color="#707070"
                className={classes.searchHistory_heading}
              >
                Search History
              </Text>
              <span
                onClick={() => downloadAsExcel(historydata)}
                className={classes.exportfile}
              >
                <FileDownloadIcon className={classes.fileDownload_icon} />
                Export Report
              </span>
            </Stack>
            <Box className={classes.searchBox}>
              <Paper className={classes.searchBox_paper}>
                <IconButton type="submit" sx={{ p: "5px" }} aria-label="search">
                  <GridSearchIcon />
                </IconButton>
                <InputBase
                  sx={{ ml: 1, flex: 1 }}
                  placeholder="Search"
                  onChange={(e) =>
                    searchhandleChange("inputsearch", e.target.value)
                  }
                  inputProps={{ "aria-label": "search" }}
                />
              </Paper>
              {/* <FilterListOutlinedIcon
                style={{ marginLeft: "10px", cursor: "pointer" }}
                // onClick={() => toggleDrawer(true)}
              /> */}
            </Box>
            <Box sx={{ display: "flex", gap: 2 }}>
              <Box
                sx={{
                  minWidth: 200,
                  maxWidth: 200,
                  marginRight: "10px",
                  marginTop: "1rem",
                }}
              >
                <FormControl fullWidth size="small">
                  <InputLabel
                    sx={{ fontSize: "15px", color: "#9e9e9e" }}
                    id="demo-simple-select-label"
                  >
                    Select Filter
                  </InputLabel>

                  <Select
                    sx={{ fontSize: "15px" }}
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    label="Select Filter"
                    value={sortingValue?sortingValue:"All"}
                    onChange={handleChangeSorting}
                  >
                    {filterData.map((option, index) => (
                      <MenuItem key={index} value={option}>
                        {option}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              <Box sx={{ maxWidth: 200, minWidth: 200, marginTop: "1rem" }}>
                <FormControl fullWidth size="small">
                  <InputLabel
                    sx={{ fontSize: "13px", marginLeft: "-5px" }}
                    id="daterange-label"
                  >
                    Date Range
                  </InputLabel>
                  <OutlinedInput
                    label="Date Range"
                    className={classes.table_date}
                    id="outlined-adornment-amount"
                    value={
                      fromat_date_from && fromat_date_to
                        ? `${fromat_date_from} - ${fromat_date_to}`
                        : ""
                    }
                    onClick={handleDatePickerOpen}
                    endAdornment={
                      <InputAdornment position="end" sx={{ cursor: "pointer" }}>
                        <EventIcon />
                      </InputAdornment>
                    }
                  />
                </FormControl>
                <div></div>
              </Box>
            </Box>
            <Dialog
              open={datePickerOpen !== undefined ? datePickerOpen : false}
              onClose={handleDatePickerClose}
              title="Select a date range"
              children={
                <DatePickerModal
                  onClose={handleDatePickerClose}
                  onDatePickerSub={onDatePickerSub}
                  from_date={from_date}
                  to_date={to_date}
                  handleChange={onChange}
                  handleReset={handleReset}
                />
              }
            />
          </Box>
          <CTable
            columns={columns}
            data={filterdata ?? []}
            isLoading={isLoading}
            pagination={true}
            page={page}
            rowsPerPage={limit}
            count={totalCount}
            onPageChange={onPageChange}
          />
        </CardContent>
      </Card>
    </Box>
  );
};

export default SearchHistory;
